module.exports = __webpack_public_path__ + "media/recipes/84-511373f9.png";